import {PatchFilter, PatchSavedSearch} from '../index';
import {Column} from '../../../../../../stores/Form';
import {createNewFilter} from '../utils';

type Action<T, P = Record<string, never>> = {
    type: T;
    payload?: P;
};

export type AdvancedSearchDrawerState = {
    search: PatchSavedSearch | null;
    showFilterFieldDropdown: boolean;
    isAISearchAllowed: boolean;
};

export type AdvancedSearchDrawerAction =
    | Action<'UPDATE_SEARCH', Partial<PatchSavedSearch>>
    | Action<'UPDATE_FILTER', {filter: PatchFilter; columnId: number}>
    | Action<'REMOVE_FILTER', {columnId: number}>
    | Action<'ADD_FILTER', {column: Column}>
    | Action<'SET_FILTERS', {filters: PatchFilter[]}>
    | Action<'UPDATE_IGNORE_CASE'>
    | Action<'STATE_UPDATE', Partial<AdvancedSearchDrawerState>>;

export type AdvancedSearchDrawerReducerType = (
    state: AdvancedSearchDrawerState,
    action: AdvancedSearchDrawerAction
) => AdvancedSearchDrawerState;

export const initialState: AdvancedSearchDrawerState = {
    search: null,
    showFilterFieldDropdown: true,
    isAISearchAllowed: false
};

export function reducer(state: AdvancedSearchDrawerState, action: AdvancedSearchDrawerAction) {
    switch (action.type) {
        case 'UPDATE_SEARCH':
            return {
                ...state,
                search: {...state.search, ...action.payload}
            };
        case 'UPDATE_FILTER':
            return {
                ...state,
                search: {
                    ...state.search,
                    filters: state.search.filters.map((searchFilter: PatchFilter) => {
                        if (searchFilter.Condition[0].columnID === action.payload.columnId) {
                            return action.payload.filter;
                        }
                        return searchFilter;
                    })
                }
            };
        case 'REMOVE_FILTER':
            return {
                ...state,
                search: {
                    ...state.search,
                    filters: state.search.filters.filter(
                        filter => filter?.Condition[0].columnID !== action.payload.columnId
                    )
                }
            };
        case 'ADD_FILTER':
            const {column} = action.payload;

            function getUpdatedSearch() {
                if (state.search.filters.find(f => f.Condition[0].columnID === column.ID)) {
                    return state.search;
                }

                return {
                    ...state.search,
                    filters: [...state.search.filters, createNewFilter(column)]
                };
            }

            return {
                ...state,
                search: getUpdatedSearch(),
                showFilterFieldDropdown: false
            };

        case 'SET_FILTERS': {
            return {
                ...state,
                search: {
                    ...state.search,
                    filters: action.payload.filters
                }
            };
        }

        case 'UPDATE_IGNORE_CASE':
            const {ignoreCase} = state.search;

            return {
                ...state,
                search: {
                    ...state.search,
                    ignoreCase: !ignoreCase,
                    filters: state.search.filters.map(filter => ({
                        ...filter,
                        Condition: filter.Condition.map(cond => ({
                            ...cond,
                            ignoreCase: !ignoreCase
                        }))
                    }))
                }
            };
        default:
            return {...state, ...action.payload};
    }
}
